import { AutocompleteAddress } from '@/components/input'

const LOCAL_LOCATION = 'locations'

const MAX_RECENT_LOCATIONS = 5

export const useRecentLocation = () => {
  const recentLocationString = localStorage.getItem(LOCAL_LOCATION)

  const recentLocations: AutocompleteAddress[] | null = recentLocationString ? JSON.parse(recentLocationString) : null

  const addRecentLocation = (location: AutocompleteAddress) => {
    if (!recentLocations) {
      localStorage.setItem(LOCAL_LOCATION, JSON.stringify([location]))
    } else if (recentLocations && recentLocations.find((loc) => loc.placeId === location.placeId)) {
      //pass
    } else if (recentLocations.length < MAX_RECENT_LOCATIONS) {
      recentLocations.unshift(location)
      localStorage.setItem(LOCAL_LOCATION, JSON.stringify(recentLocations))
    } else {
      recentLocations.splice(recentLocations.length - 1, 1)
      recentLocations.unshift(location)
      localStorage.setItem(LOCAL_LOCATION, JSON.stringify(recentLocations))
    }
  }

  return { recentLocations, addRecentLocation }
}
